import { Theme } from '@eversports/react-components/design-tokens/theme'
import Animation from '@eversports/react-components/primitives/Animation'
import Dialog, { DialogContent, DialogTitle } from '@eversports/react-components/primitives/Dialog'
import Flex from '@eversports/react-components/primitives/Flex'
import Heading from '@eversports/react-components/primitives/Heading'
import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { PurchaseOption } from '../../typings/Product'

import ProductInformationDialogContent from './ProductInformationDialogContent'

interface Props {
  product: PurchaseOption
  isOpen: boolean
  onClose: () => void
}

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    padding: `0 ${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(4)}`,
    minWidth: 450,
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
    },
  },
  title: {
    padding: `${theme.spacing(2)} ${theme.spacing(1)}`,
  },
  closeIcon: {
    cursor: 'pointer',
    marginLeft: theme.layoutSpacing.hero,
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.layoutSpacing.dense,
    },
  },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Animation variant="grow" timeout={1000} ref={ref} {...props} />
})
const ProductInformationDialog: React.FC<React.PropsWithChildren<Props>> = ({ product, isOpen, onClose }) => {
  const classes = useStyles()

  return (
    // @ts-ignore The transition component has typing issues
    <Dialog open={isOpen} onClose={onClose} TransitionComponent={Transition} maxWidth="md">
      <DialogTitle className={classes.title}>
        <Flex justifyContent="space-between" alignItems="baseline">
          <Flex flexDirection="column">
            <Heading is="h5">{product.name}</Heading>
            {product.__typename === 'Membership' && product.description && <Text>{product.description}</Text>}
          </Flex>
          <Icon icon={Icons.CLOSE} size="large" onClick={onClose} className={classes.closeIcon} />
        </Flex>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <ProductInformationDialogContent product={product} />
      </DialogContent>
    </Dialog>
  )
}

export default ProductInformationDialog
